import { useRoutes } from 'react-router';

import logo from '../assets/images/logo.svg?url';

import { useCurrentUser } from '@/providers/CurrentUserProvider';
import { useRouteConfig } from './routeConfigs/useRouteConfig';
import { useDispatch, useSelector } from 'react-redux';
import { isCoachUser } from '@/services/CompanyService';
import { selectActiveEnterpriseId } from '@/slices/activeContext/activeContext.selector';
import enterpriseApi from '@/slices/enterprises/enterprise.api';
import { useEffect } from 'react';
import { setActiveEnterpriseId } from '@/slices/activeContext/activeContext.slice';
import { useCurrentAuth } from '@/providers/CurrentAuthProvider';

export function ScreensRouter() {
  const currentAuth = useCurrentAuth();
  const routes = useRoutes(useRouteConfig());
  const { isLoading } = useInitData();

  const isLogged = typeof currentAuth === 'undefined';

  if (isLogged && isLoading) {
    return (
      <div className="flex h-screen w-screen">
        <img className="m-auto w-24 h-24" src={logo} alt="" />
      </div>
    );
  }

  return routes;
}

const useInitData = () => {
  const dispatch = useDispatch();
  const { currentUser } = useCurrentUser();
  const isCoach = isCoachUser(currentUser);
  const activeEnterpriseId = useSelector(selectActiveEnterpriseId);

  const [getActiveEnterprise] =
    enterpriseApi.endpoints.getEnterprise.useLazyQuery();

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    if (activeEnterpriseId) {
      getActiveEnterprise({ enterpriseId: activeEnterpriseId });
      return;
    }

    if (!isCoach && currentUser.company?.id) {
      dispatch(setActiveEnterpriseId(currentUser.company.id));
    }
  }, [activeEnterpriseId, currentUser, isCoach]);

  return {
    isLoading: typeof currentUser === 'undefined',
  };
};
